module.exports = __webpack_public_path__ + "cb59e1674158b6b0b4cea5f561ce1c44.png";